export default "__VITE_PUBLIC_ASSET__e14eaa14__"